module.exports = __webpack_public_path__ + "static/img/common.a82ec5da.png";